/* Noon — Interactive theme B */
(function () {
  if (window.__noonBInit) return;
  window.__noonBInit = true;

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  function hex(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
  function mix(a, b, t) { var A = hex(a), B = hex(b); return 'rgb(' + A.map(function (v, i) { return Math.round(v + (B[i] - v) * t); }).join(',') + ')'; }

  /* ---------- lazy videos (Seedance clips) ---------- */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.__loaded) {
          $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; });
          v.load(); v.__loaded = true;
        }
        if (!RM && !v.__userPaused && !v.hasAttribute('data-nn-manual')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '200px 0px' }) : null;
  function initVideo(v) {
    if (v.__nn) return; v.__nn = true;
    if (vio) vio.observe(v);
    else { $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; }); v.load(); }
  }
  function playVideo(v) {
    if (!v) return;
    if (!v.__loaded) { $$('source[data-src]', v).forEach(function (s) { s.src = s.dataset.src; }); v.load(); v.__loaded = true; }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  /* ---------- hero coffee beans ---------- */
  function initBeans(canvas) {
    if (canvas.__nn) return; canvas.__nn = true;
    var host = canvas.parentElement, ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, beans = [], running = false, raf = 0;
    var pointer = { x: -999, y: -999 };
    var count = parseInt(canvas.dataset.count, 10) || 26;
    var tones = ['#2B170C', '#3A2213', '#4B2D18', '#5A3A22', '#6B4429'];
    function size() {
      var r = host.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function bean(x, y, burst) {
      var s = 9 + Math.random() * 9;
      var a = Math.random() * Math.PI * 2, sp = burst ? 3 + Math.random() * 5 : 0;
      return { x: x, y: y, s: s, r: Math.random() * Math.PI * 2, vr: (Math.random() - .5) * .02,
        vx: burst ? Math.cos(a) * sp : (Math.random() - .5) * .25, vy: burst ? Math.sin(a) * sp - 2 : .25 + Math.random() * .45,
        c: tones[(Math.random() * tones.length) | 0], life: burst ? 220 : -1 };
    }
    function seed() {
      beans = [];
      var n = W < 700 ? Math.round(count * .55) : count;
      for (var i = 0; i < n; i++) beans.push(bean(Math.random() * W, Math.random() * H, false));
    }
    function draw(b) {
      ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.r);
      ctx.globalAlpha = b.life > 0 ? Math.min(1, b.life / 60) : 1;
      ctx.fillStyle = b.c;
      ctx.beginPath(); ctx.ellipse(0, 0, b.s * .72, b.s, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,.08)';
      ctx.beginPath(); ctx.ellipse(-b.s * .22, -b.s * .25, b.s * .22, b.s * .42, -.3, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(253,215,66,.55)'; ctx.lineWidth = Math.max(1.2, b.s * .12); ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(0, -b.s * .78);
      ctx.bezierCurveTo(b.s * .32, -b.s * .25, -b.s * .32, b.s * .25, 0, b.s * .78); ctx.stroke();
      ctx.restore();
    }
    function step() {
      ctx.clearRect(0, 0, W, H);
      for (var i = beans.length - 1; i >= 0; i--) {
        var b = beans[i], dx = b.x - pointer.x, dy = b.y - pointer.y, d2 = dx * dx + dy * dy;
        if (d2 < 14400) { var d = Math.sqrt(d2) || 1, f = (120 - d) / 120 * 1.6; b.vx += dx / d * f; b.vy += dy / d * f; b.vr += (Math.random() - .5) * .02; }
        if (b.life > 0) { b.vy += .12; b.life--; if (b.life <= 0 || b.y > H + 40) { beans.splice(i, 1); continue; } }
        else { b.vx *= .94; b.vy = b.vy * .94 + .03; if (b.vy < .2) b.vy += .02; }
        b.x += b.vx; b.y += b.vy; b.r += b.vr; b.vr *= .995;
        if (b.life < 0) {
          if (b.y > H + 30) { b.y = -30; b.x = Math.random() * W; b.vx = (Math.random() - .5) * .25; b.vy = .3 + Math.random() * .4; }
          if (b.x < -30) b.x = W + 30; if (b.x > W + 30) b.x = -30;
        }
        draw(b);
      }
      if (running) raf = requestAnimationFrame(step);
    }
    function start() { if (running || RM) return; running = true; raf = requestAnimationFrame(step); }
    function stop() { running = false; cancelAnimationFrame(raf); }
    size(); seed();
    if (RM) { step(); }
    else start();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }).observe(host);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { size(); seed(); if (RM) step(); }, 150); });
    host.addEventListener('pointermove', function (e) { var r = host.getBoundingClientRect(); pointer.x = e.clientX - r.left; pointer.y = e.clientY - r.top; });
    host.addEventListener('pointerleave', function () { pointer.x = pointer.y = -999; });
    host.addEventListener('click', function (e) {
      if (RM || e.target.closest('a,button,input,select,textarea,label')) return;
      var r = host.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
      for (var i = 0; i < 14; i++) beans.push(bean(x, y, true));
    });
  }

  /* ---------- pour your half-caff ---------- */
  function initPour(root) {
    if (root.__nn) return; root.__nn = true;
    var cap = 100, reg = 0, dec = 0, timer = 0, which = null;
    var mgFull = parseFloat(root.dataset.mg) || 95;
    var liquid = root.querySelector('.nn-mug__liquid'), mug = root.querySelector('.nn-mug__body');
    var spouts = { reg: root.querySelector('.nn-spout--reg'), dec: root.querySelector('.nn-spout--decaf') };
    var bars = root.querySelectorAll('.nn-pour__bar span');
    var o = function (k) { return root.querySelector('[data-out="' + k + '"]'); };
    var msg = o('msg'), cta = root.querySelector('[data-pour-cta]');
    var lo = parseFloat(root.dataset.lo) || 45, hi = parseFloat(root.dataset.hi) || 55;
    function streamLen(sp) {
      if (!sp) return;
      var st = sp.querySelector('.nn-stream'); if (!st) return;
      var top = st.getBoundingClientRect().top, surf = liquid.getBoundingClientRect().top;
      if (!liquid.offsetHeight) surf = mug.getBoundingClientRect().bottom - 4;
      sp.style.setProperty('--nn-stream', Math.max(20, surf - top + 4) + 'px');
    }
    function render() {
      var tot = reg + dec, f = tot / cap, share = tot ? reg / tot : 0;
      liquid.style.height = (f * 100) + '%';
      liquid.style.backgroundColor = mix('#2B170C', '#7A4B2A', tot ? dec / tot : 0);
      bars[0].style.width = (reg / cap * 100) + '%'; bars[1].style.width = (dec / cap * 100) + '%';
      o('reg').textContent = tot ? Math.round(share * 100) + '%' : '—';
      o('dec').textContent = tot ? Math.round((1 - share) * 100) + '%' : '—';
      o('mg').textContent = Math.round(reg / cap * mgFull);
      root.classList.toggle('is-full', tot >= cap);
      root.classList.toggle('is-deep', f > .3);
      if (tot >= cap) {
        var pct = share * 100, win = pct >= lo && pct <= hi;
        root.classList.toggle('is-win', win);
        msg.textContent = win ? (root.dataset.win || "That's a Noon cup. Same ritual, half the buzz.")
          : pct > hi ? 'Whoa — that one will hum. Try more decaf for a Noon cup.'
          : 'Cozy and calm. Add a little more regular for a Noon cup.';
        if (cta) cta.hidden = !win;
      } else {
        root.classList.remove('is-win');
        msg.textContent = tot ? 'Keep pouring…' : (root.dataset.idle || 'Hold a button to pour. Aim for 50/50.');
        if (cta) cta.hidden = true;
      }
    }
    function tick() {
      if (!which) return;
      if (reg + dec < cap) { if (which === 'reg') reg = Math.min(cap - dec, reg + 1.1); else dec = Math.min(cap - reg, dec + 1.1); }
      render(); streamLen(spouts[which]);
      if (reg + dec >= cap) { stopPour(); return; }
      timer = requestAnimationFrame(tick);
    }
    function startPour(w, btn) {
      if (which || reg + dec >= cap) return;
      which = w; btn.classList.add('is-pouring'); spouts[w].classList.add('is-pouring'); streamLen(spouts[w]);
      timer = requestAnimationFrame(tick);
    }
    function stopPour() {
      cancelAnimationFrame(timer);
      $$('.is-pouring', root).forEach(function (el) { el.classList.remove('is-pouring'); });
      which = null;
    }
    $$('[data-pour]', root).forEach(function (btn) {
      var w = btn.dataset.pour;
      btn.addEventListener('pointerdown', function (e) { e.preventDefault(); try { btn.setPointerCapture(e.pointerId); } catch (x) {} startPour(w, btn); });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { btn.addEventListener(ev, stopPour); });
      btn.addEventListener('keydown', function (e) { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); startPour(w, btn); } });
      btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') stopPour(); });
      btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    });
    var reset = root.querySelector('[data-pour-reset]');
    if (reset) reset.addEventListener('click', function () { stopPour(); reg = dec = 0; render(); });
    render();
  }

  /* ---------- bean-to-cup journey ---------- */
  function initJourney(root) {
    if (root.__nn) return; root.__nn = true;
    var steps = $$('.nn-journey__step', root), shots = $$('.nn-journey__media .nn-journey__shot', root);
    var bar = root.querySelector('.nn-journey__progress span');
    function activate(i) {
      steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      shots.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (k === i) { s.setAttribute('data-active', ''); if (v && !RM) playVideo(v); }
        else { s.removeAttribute('data-active'); if (v && !v.paused) v.pause(); }
      });
      if (bar) bar.style.width = ((i + 1) / steps.length * 100) + '%';
    }
    if (!('IntersectionObserver' in window)) { activate(0); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
    activate(0);
  }

  /* ---------- brew guide + timer ---------- */
  function fmt(s) { s = Math.max(0, Math.ceil(s)); var m = Math.floor(s / 60), r = s % 60; return m + ':' + (r < 10 ? '0' : '') + r; }
  function initBrew(root) {
    if (root.__nn) return; root.__nn = true;
    var tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root);
    var ring = root.querySelector('.nn-ring__fg'), timeEl = root.querySelector('.nn-ring__time'), label = root.querySelector('.nn-ring__label');
    var startBtn = root.querySelector('[data-brew-start]'), resetBtn = root.querySelector('[data-brew-reset]'), msg = root.querySelector('.nn-brew__msg');
    var C = 2 * Math.PI * 104, total = 0, left = 0, last = 0, raf = 0, on = false;
    if (ring) { ring.style.strokeDasharray = C; ring.style.strokeDashoffset = 0; }
    function paint() {
      timeEl.textContent = fmt(left);
      if (ring) ring.style.strokeDashoffset = total ? C * (1 - left / total) : 0;
    }
    function stop(done) {
      on = false; cancelAnimationFrame(raf); root.classList.remove('is-running');
      startBtn.textContent = done ? 'Brew again' : (left < total ? 'Resume' : 'Start timer');
      if (done) { msg.textContent = root.dataset.done || 'Done! Pour, sip, and enjoy your Noon.'; label.textContent = 'Ready'; }
    }
    function loop(t) {
      if (!on) return;
      left -= (t - last) / 1000; last = t;
      if (left <= 0) { left = 0; paint(); stop(true); return; }
      paint(); raf = requestAnimationFrame(loop);
    }
    function load(i) {
      var p = panels[i];
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (q, k) { q.hidden = k !== i; });
      stop(false);
      total = left = parseFloat(p.dataset.seconds) || 240;
      label.textContent = p.dataset.label || 'Brew time'; msg.textContent = ''; startBtn.textContent = 'Start timer';
      paint();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { load(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!k) return; e.preventDefault(); var n = (i + k + tabs.length) % tabs.length; tabs[n].focus(); load(n);
      });
    });
    startBtn.addEventListener('click', function () {
      if (on) { stop(false); return; }
      if (left <= 0) left = total;
      on = true; last = performance.now(); root.classList.add('is-running'); startBtn.textContent = 'Pause'; msg.textContent = '';
      raf = requestAnimationFrame(loop);
    });
    resetBtn.addEventListener('click', function () { stop(false); left = total; startBtn.textContent = 'Start timer'; msg.textContent = ''; paint(); });
    if (panels.length) load(0);
  }

  /* ---------- cinematic band ---------- */
  function initCinema(root) {
    if (root.__nn) return; root.__nn = true;
    var frame = root.querySelector('.nn-cinema__frame'), v = root.querySelector('video'), t = root.querySelector('.nn-cinema__toggle');
    if (t && v) {
      if (RM) t.setAttribute('aria-pressed', 'true');
      t.addEventListener('click', function () {
        if (v.paused) { v.__userPaused = false; playVideo(v); t.setAttribute('aria-pressed', 'false'); t.setAttribute('aria-label', 'Pause video'); }
        else { v.__userPaused = true; v.pause(); t.setAttribute('aria-pressed', 'true'); t.setAttribute('aria-label', 'Play video'); }
      });
    }
    if (RM || !frame) return;
    var tk = false;
    function upd() {
      tk = false;
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      var p = clamp((vh - r.top) / (vh + r.height * .35), 0, 1);
      frame.style.setProperty('--s', (.86 + .14 * Math.min(1, p * 1.6)).toFixed(3));
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- reel: hover to play ---------- */
  function initReel(root) {
    if (root.__nn) return; root.__nn = true;
    $$('.nn-reel__card', root).forEach(function (c) {
      var v = c.querySelector('video'); if (!v) return;
      c.addEventListener('pointerenter', function () { playVideo(v); });
    });
  }

  /* ---------- scroll cup (page progress fills a mug) ---------- */
  function initCup(el) {
    if (el.__nn) return; el.__nn = true;
    var tk = false;
    function upd() {
      tk = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? clamp(window.scrollY / h, 0, 1) : 0;
      el.style.setProperty('--fill', p.toFixed(3));
      el.classList.toggle('is-on', window.scrollY > 400);
      el.classList.toggle('is-full', p > .985);
    }
    window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(upd); } }, { passive: true });
    el.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' }); });
    upd();
  }

  function init(scope) {
    scope = scope || document;
    $$('video[data-nn-video]', scope).forEach(initVideo);
    $$('canvas.nn-beans', scope).forEach(initBeans);
    $$('[data-nn-pour]', scope).forEach(initPour);
    $$('[data-nn-journey]', scope).forEach(initJourney);
    $$('[data-nn-brew]', scope).forEach(initBrew);
    $$('[data-nn-cinema]', scope).forEach(initCinema);
    $$('[data-nn-reel]', scope).forEach(initReel);
    $$('[data-nn-cup]', scope).forEach(initCup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
